module.exports = __webpack_public_path__ + "img/goal-nine-en.b2788404.png";